"use client";

import "./Contact.module.css";
import React, { useState } from "react";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Mail, MapPin, Phone } from "lucide-react";
import Contact from "./sections/Contact";
const officeAddress = "Cevizli Mahallesi, Mustafa Kemal Caddesi, Onat Sokak, No:5/8, Kartal/İstanbul";
const mapSrc = "https://www.google.com/maps?q=40.9112408,29.1721365&z=18&output=embed";
const contactRows = [{
  label: "Ofis Adresi",
  value: officeAddress,
  icon: MapPin
}, {
  label: "E-posta",
  value: "info@yuksekbas.av.tr",
  href: "mailto:info@yuksekbas.av.tr",
  icon: Mail
}, {
  label: "Telefon",
  value: "+90 (216) 706 41 50",
  href: "tel:+902167064150",
  icon: Phone
}];
function ContactInfo() {
  return <div className="min-w-0 border-t border-[#111111]/18">
      {contactRows.map(row => {
      const Icon = row.icon;
      const content = <>
            <div className="flex items-center gap-3 font-sans text-sm text-[#111111]/48">
              <Icon className="size-4" />
              <span>{row.label}</span>
            </div>
            <p className="mt-4 font-serif text-[clamp(1.3rem,2vw,2rem)] font-normal leading-snug text-[#111111] break-words">
              {row.value}
            </p>
          </>;
      return row.href ? <a key={row.label} href={row.href} className="block border-b border-[#111111]/18 py-6 transition-colors hover:bg-[#111111]/[0.035] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#111111] focus-visible:ring-offset-2 focus-visible:ring-offset-[#f4efe5]">
            {content}
          </a> : <div key={row.label} className="border-b border-[#111111]/18 py-6">
            {content}
          </div>;
    })}
    </div>;
}
function ContactForm() {
  function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
  }
  const fieldClass = "min-h-12 w-full rounded-none border border-[#111111]/22 bg-transparent px-4 py-3 font-sans text-base text-[#111111] outline-none transition-colors placeholder:text-[#111111]/34 focus:border-[#111111] focus:ring-2 focus:ring-[#111111]/18";
  return <form onSubmit={handleSubmit} className="border-t border-[#111111]/18 pt-6">
      <div className="grid gap-5">
        <div>
          <label htmlFor="contact-page-full-name" className="mb-2 block font-sans text-sm text-[#111111]/66">
            Ad Soyad
          </label>
          <input id="contact-page-full-name" name="fullName" type="text" autoComplete="name" className={fieldClass} />
        </div>

        <div>
          <label htmlFor="contact-page-email" className="mb-2 block font-sans text-sm text-[#111111]/66">
            E-posta
          </label>
          <input id="contact-page-email" name="email" type="email" autoComplete="email" className={fieldClass} />
        </div>

        <div>
          <label htmlFor="contact-page-phone" className="mb-2 block font-sans text-sm text-[#111111]/66">
            Telefon <span className="text-[#111111]/42">(isteğe bağlı)</span>
          </label>
          <input id="contact-page-phone" name="phone" type="tel" autoComplete="tel" className={fieldClass} />
        </div>

        <div>
          <label htmlFor="contact-page-message" className="mb-2 block font-sans text-sm text-[#111111]/66">
            Mesaj
          </label>
          <textarea id="contact-page-message" name="message" rows={5} className={fieldClass} />
        </div>
      </div>

      <div className="mt-6 flex justify-end">
        <button type="submit" disabled className="inline-flex min-h-12 items-center justify-center border border-[#111111]/28 px-6 font-sans text-sm text-[#111111]/46">
          Mesaj Gönder
        </button>
      </div>
    </form>;
}
function MapPanel() {
  const [mapVisible, setMapVisible] = useState(false);
  return <div className="mt-10 border border-[#111111]/18 bg-[#ede6d8]">
      {mapVisible ? <iframe title="Onat Sokak No:5 ofis konumu haritası" src={mapSrc} className="aspect-[16/10] w-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" /> : <div className="flex aspect-[16/10] min-h-[260px] flex-col items-start justify-end gap-5 p-6 sm:p-8">
          <p className="max-w-xl font-serif text-[clamp(1.7rem,3vw,3rem)] font-normal leading-tight text-[#111111]">
            Harita yalnızca isteğinizle yüklenir.
          </p>
          <button type="button" onClick={() => setMapVisible(true)} className="inline-flex min-h-12 items-center border border-[#111111]/32 px-5 font-sans text-sm text-[#111111] transition-colors hover:bg-[#111111] hover:text-[#f4efe5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#111111] focus-visible:ring-offset-2 focus-visible:ring-offset-[#ede6d8]">
            Haritayı Göster
          </button>
        </div>}
    </div>;
}
export default function ContactPage() {
  return <div className="min-h-screen bg-[#f4efe5] text-[#111111]">
      <Header />
      <main>
        <section className="mx-auto grid max-w-[1320px] gap-10 px-5 py-14 sm:px-8 md:py-20 lg:grid-cols-[minmax(0,0.34fr)_minmax(0,0.66fr)] lg:px-10 lg:py-24">
          <div className="min-w-0 border-t border-[#111111]/16 pt-8">
            <h1 className="font-serif text-[clamp(3rem,5.8vw,5.85rem)] font-normal leading-[0.96] tracking-[-0.03em] text-[#111111]">
              İletişim
            </h1>
          </div>
          <div className="min-w-0">
            <div className="grid gap-10 xl:grid-cols-[minmax(0,0.38fr)_minmax(0,0.62fr)] xl:gap-12">
              <ContactInfo />
              <Contact />
            </div>
            <MapPanel />
          </div>
        </section>
      </main>
      <Footer />
    </div>;
}